import { NavBar } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';
import theme from 'styled-theming';

const newGenesisTabColor = theme('name', {
  light: '#757575',
  dark: 'rgba(255, 255, 255, 0.57)',
});

const newGenesisActiveTabColor = theme('name', {
  light: '#404040',
  dark: '#FFFFFF',
});

const newGenesisLayoutBackgroundColor = theme('name', {
  light: 'rgb(242, 242, 242)',
  dark: '#1C1C1C',
});

const newGenesisHeaderBackgroundColor = theme('name', {
  light: '#ffffff',
  dark: '#2C2C2C',
});

export const NewGenesisContainer = styled.div`
  position: relative;
  font-family: 'system-ui', sans-serif;
  background-color: ${newGenesisLayoutBackgroundColor};
  color: ${(prop) => prop.color};
  height: 100vh;

  .shell-menu-label {
    color: ${newGenesisTabColor} !important;
  }

  .shell-menu-item-selected > .shell-menu-label {
    color: ${newGenesisActiveTabColor} !important;
  }

  div:has(.shell-nav-bar) {
    height: 72px;
    background-color: ${newGenesisHeaderBackgroundColor};

    .shell-nav-bar {
      padding: unset;
      gap: 5px;
    }

    .shell-menu-item {
      padding: 25px 10px;
      font-size: 14px;
      font-weight: 600;
    }

    .shell-menu-horizontal .shell-menu-item.shell-menu-item-selected {
      background: unset;
      ::after {
        height: 4px;
        bottom: unset;
        top: 0;
      }
    }
  }

  .new-genesis-center-component {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
  }

  div:has(.shell-menu-horizontal) {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .shell-menu-horizontal {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .pointer {
    cursor: pointer;
  }
`;

export const MainContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const NavBarStyled = styled(NavBar)`
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const PectenWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
`;

export const NewGenesisHeader = styled.div<{ flexDirection?: string }>`
  display: flex;
  flex-direction: ${(props) => props.flexDirection ?? 'row'};
  align-items: flex-start;
  gap: 2px;
`;

export const AvatarArea = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
`;

export const NewGenesisSwitchAppButton = styled.div`
  .new-genesis-switch-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 6px;
    background-color: transparent;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(67, 233, 123, 0.1);
      border-color: #43e97b;
    }
  }
`;

export const NewGenesisMidSection = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 72px);
  overflow: hidden;
`;

export const NewGenesisContentContainer = styled.div`
  flex: 1;
  overflow: auto;
  background-color: ${newGenesisLayoutBackgroundColor};
`;
